import React, { Component } from "react";
import { connect } from "react-redux";
import "./widget.scss";
import DriveItems from "./components/driveItems/DriveItems";
import Loader from "./components/loading/Loader";
import DriveItemFullScreen from './components/driveItemFullScreen/DriveItemFullScreen';
import EditorError from './components/editorError/EditorError';
import parameters from '../config/parameters';
import WixBiService from '../utils/WixBIService';
import Wix from "../utils/wixService";
import axios from 'axios';
import httpRequest from "./api/httpRequests"
import { injectIntl } from 'react-intl';

import {
  setDisplayTitle,
  setUserName,
  setCanEdit,
  setIsNewFile,
  setIsNewFileMobile
} from "../actions/widgetAction";

class Widget extends Component {
  state = {
    settingsUpdate: {},
    showBox: false,
    size: "1",
    sortDefault: "1",
    changeMode: false,
    viewMode:Wix.Utils.getViewMode(),
    private: false,
    connectNoSelect: false,
    displayLoad: false,
    deviceType: Wix.Utils.getDeviceType(),
    listItemFontClass: '',
    navigationFontClass: '',
    src: parameters["DEFAULT_FILE_SRC"]
  };

  componentDidMount = () => {
    Wix.applicationLoadingStep(10);
    if(Wix.isMobile() && Wix.isEditorMode() ) {
      this.windowResizeMobile();
    }
    window.addEventListener('resize', (/* e */) => {
      if (!Wix.isMobile()) {
        const minWidth = 400;
        const height = window.innerHeight;
        if( window.innerWidth < minWidth )
        {
          this.resizeComponent(minWidth, height);
        }
      }
    });

    const compId = Wix.Utils.getCompId();
    this.compId = compId;
    this.refreshToken();
    this.getDataPublic();

    Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, data =>
      this.onSettingsUpdate(data, compId)
    );

    Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, (event) => {
      if (event.editMode == "editor" || event.editMode == "preview") {
        this.setState({changeMode: !this.state.changeMode , viewMode: event.editMode})
      }
    });

    Wix.addEventListener(Wix.Events.SITE_SAVED, () => {
      WixBiService.triggerEvent('site_save', this._collectData);
    });

    Wix.addEventListener(Wix.Events.SITE_PUBLISHED, () => {
      WixBiService.triggerEvent('site_save', this._collectData);
    });

    Wix.addEventListener(Wix.Events.COMPONENT_DELETED, () => {
      this.getDataPublic();
      Wix.Data.Public.set(
        compId,
        {
          ...this.state.dataPublic,
          deletedAt: new Date()
        },
        { scope: "COMPONENT" },
         (data) => {
          this.deleteComponent(data, compId);
        }
      );
    });

    Wix.Styles.getStyleParams(style => {
      this.updateStyle(style);
    });

    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, style => {
      this.updateStyle(style);
    });

    Wix.addEventListener(Wix.Events.DEVICE_TYPE_CHANGED, deviceTypeObject => {
      if(!Wix.isMobile()) {
        this.deviceType = "mobile";
      }
      else {
        this.deviceType = "desktop";
      }
    });
  };

  windowResizeMobile() {
    if (window.innerHeight < 272 && (typeof this.dataPublic === "undefined" || typeof this.dataPublic.changeMobileHeight  === "undefined" )) {
        Wix.setHeight(272);
        if (this.dataPublic)
          Wix.Data.Public.set(
            this.compId,
            {
              ...this.dataPublic,
              changeMobileHeight: true
            },
            { scope: "COMPONENT" },
            (data) => {
              console.log("windowResizeMobile",data)
            }
          );
      }

  }

   _collectData = () => {
    return {
        wixlabs_bool_1:   this.state.connectNoSelect,
        wixlabs_string_1: this.state.fileId ? this.mimeType : '',//mimeType type
        Wixlabs_string_2: this.state.fileId ? this.props.canEdit : ''
    };
    };

  updateStyle = style => {
    let stateObject = {}
    if(style.numbers){
      if (style.numbers.select_sort) {
        stateObject.sortDefault = String(style.numbers.select_sort);
      }
      if(style.numbers.borderWidth || style.numbers.cornerRadius){
        stateObject.noOldSettings = 1
      }
      if(style.fonts){
        if(style.fonts.listItemFont && style.fonts.listItemFont.size > 24){
          stateObject.listItemFontClass = " listItemFontClassSize";
        }
        else {
          stateObject.listItemFontClass = ''
        }
        if(style.fonts.navigationFont && style.fonts.navigationFont.size > 24){
          stateObject.navigationFontClass = " navigationFontClassSize";
        }
        else {
          stateObject.navigationFontClass = '';
        }
      }
    }
    if (Object.keys(stateObject).length > 0 )
      this.setState(stateObject);
  };

  resizeComponent(width,height){
      Wix.resizeComponent({
        width:  width,
        height: height
      });
   }

  setPublicFileCallback = (isPublic, activeFileId,resourceKey ) => {
    Wix.applicationLoaded();
    if (isPublic) {
      this.setState({ private: false, fileId: activeFileId, displayLoad: false, connectNoSelect: false, isSignleFile: this.isSignleFile, src: this.src, mimeType: this.mimeType, oldSettings: this.oldSettings, noOldSettings: this.noOldSettings , resourceKey:resourceKey});
      this.props.setCanEdit(this.editable);
    } else {
      this.setState({ private : true, displayLoad: false });
    }
  }
  setPublicFileCallbackSave = (isPublic, activeFileId, src ,resourceKey) => {
    if (isPublic) {
      this.setState({ private: false, fileId: activeFileId, src, displayLoad: false, connectNoSelect: false, isSignleFile: this.isSignleFile, mimeType: this.mimeType, resourceKey:resourceKey});
      this.props.setIsNewFile(true);
      this.props.setIsNewFileMobile(true);
      axios.post("api/activeFileId" + httpRequest.getUrlQuery() + "&fileId=" + activeFileId + "&mimeType=" + this.mimeType + "&resourceKey=" + this.resourceKey).then(res => {
      })
    } else {
      this.setState({ private : true, displayLoad: false });
    }
  }

  getNewFileId = data => {
    //if (this.state.mimeType !== parameters["TYPE_FOLDER"])
       // this.windowResize(); // resize to default height after change file
    if (data.id && data.id != parameters['DEFAULT_FILE']) {
      this.mimeType = data.mimeType;
      this.resourceKey=data.resourceKey;
      this.isSignleFile = data.isSignleFile;
      this.setPublicFileCallbackSave(1, data.id, data.src,data.resourceKey);
      //isFilePublic(data.id, this.setPublicFileCallbackSave ,false);
    }
    else {
      this.setState({ private: false, src: parameters['DEFAULT_FILE_SRC'],  fileId: parameters['DEFAULT_FILE'],isSignleFile: true, displayLoad: false, connectNoSelect: false });
    }
  };


  onSettingsUpdate = (update, compId) => {
    if (compId == update.value.compId) {
      switch (update.key) {
        case "id":
          if (update.value) this.getNewFileId(update.value);
          break;
        case 'loader':
            this.setState({displayLoad: true});
          break;
        case 'stoploader':
          this.setState({ displayLoad: false});
        break;
        case "canEdit":
          this.props.setCanEdit(update.value.canEdit);
          break;
        case "private":
          this.setState({private: update.value, displayLoad: false});
          break;
        case "connectNoSelect":
          this.setState({connectNoSelect: update.value.connectNoSelect, displayLoad: false});
        break;
        case "showItems":
          this.getDataPublic();
          break;
        default:
          break;
      }
    }
  };

  getDataPublic = () => {
    Wix.Data.Public.get(this.compId, { scope: "COMPONENT" }, data => {
      try {
            data = data[this.compId];
            this.dataPublic = data;
          if(data.userName)
            this.props.setUserName(data.userName)
      }
      catch(err) {}
    });
  };

  refreshToken = () => {
    Wix.applicationLoadingStep(100)
    const refresh = () => {
        this.getFectiveAccessToken((data) => {
          //window.localStorage.setItem('fective_token', JSON.stringify(data.access_token));
          this.oldSettings = data.oldSettings;
          this.mimeType = data.mimeType;
          this.src = data.src;
          this.resourceKey = data.resourceKey;
          this.isPublic = data.isPublic;
          this.editable = data.editable;
          this.setTokenDetails(data.activeFileId, data.isPublic,data.resourceKey);
        });
    }
    refresh();
    setInterval(refresh, 300000);
  }

  getFectiveAccessToken = (callback) => {
      axios.get("/api/fileDetails" + httpRequest.getUrlQuery())
          .then(res => {
              callback(res.data);
          }).catch(err => {console.log('getAccessToken token error2',err)});
  }

  setTokenDetails = (activeFileId, isPublic,resourceKey) => {
    if (activeFileId !== parameters['DEFAULT_FILE'] && typeof activeFileId != 'undefined') {
      this.setPublicFileCallback(isPublic, activeFileId,resourceKey)
    }
    else {
      this.props.setCanEdit(false);
      this.setState({ private: false, fileId: parameters['DEFAULT_FILE'], isSignleFile: true, displayLoad: false });
    }
  }

  deleteComponent = (data, compId) => {
    localStorage.removeItem("token");
    this.setState({ dataPublic: data[compId] });
  };

  updateCompHeight = height => {
    const desiredHeight = height || document.documentElement.scrollHeight;
    // Wix.setHeight(desiredHeight);
  };

  navToHome = () => {
    Wix.getSiteMap(pages => {
      Wix.navigateToPage(pages[0].pageId.substring(1));
    });
  };

  stringify = input => {
    try {
      return JSON.stringify(input, null, 4);
    } catch (err) {
      return input;
    }
  };

  render() {
    const { deviceType } = this.state;
    const classes = `wix-style-sample ${deviceType}`;
    const viewMode = Wix.Utils.getViewMode();
    if(this.state.displayLoad)
      return (
          <div className={classes}>
              <Loader/>
          </div>
        );
      if(this.state.private ){
        return (
            viewMode!== "site" && this.state.viewMode!== "preview"?
            <div className={classes}>
                   <EditorError title={this.props.intl.formatMessage({id: 'widget.notPublicAnymore'})}
                                titleInfo={this.props.intl.formatMessage({id: 'widget.goTo'})}
                                subTitleInfo ={this.props.intl.formatMessage({id: 'widget.permissionsFor'})}/>
             </div>
            :
            <div className={classes}>
                  <EditorError  title={this.props.intl.formatMessage({id: 'widget.oops'})}  titleInfo ={this.props.intl.formatMessage({id: 'widget.wrong'})} />
           </div>

          )
    };
    if( this.state.fileId && this.state.mimeType !== parameters["TYPE_FOLDER"] || !this.state.fileId || this.state.fileId == parameters['DEFAULT_FILE'] )
        {
          return (
            this.state.fileId !== parameters['DEFAULT_FILE'] || (viewMode!== "site" /*&& this.state.viewMode!== "preview"*/)  ?
              <DriveItemFullScreen fileId={this.state.fileId} canEdit={this.props.canEdit} src={this.state.src} noBorder={ this.state.fileId == parameters['DEFAULT_FILE'] } styleOldSettings={this.state.noOldSettings ? '': this.oldSettings} resourceKey={this.state.resourceKey} />
            :
            <div className={classes}>
                  <EditorError isDefaultLiveSite={true} titleInfo={this.props.intl.formatMessage({id: 'widget.thereAreNoDocsToDisplayAtTheMoment'})}  subTitleInfo ={this.props.intl.formatMessage({id: 'widget.pleaseTryAgainLater'})} />
            </div>
          );

        }
          return (
          <div className={classes}>
              <DriveItems
                id={this.state.fileId}
                resourceKey={this.state.resourceKey}
                layoutFolder={this.state.layoutFolder}
                layoutFile={this.state.layoutFile}
                changeMode = {this.state.changeMode}
                sortDefault = {this.state.sortDefault}
                listItemFontClass =  {this.state.listItemFontClass}
                navigationFontClass =  {this.state.navigationFontClass}
              />
          </div>
    );
  }
}

const mapStateToProps = state => ({
  select_layout: state.userConnectReducer.select_layout,
  layout_file: state.userConnectReducer.layout_file,
  canEdit: state.userConnectReducer.canEdit,
  isNewFile: state.widgetReducer.isNewFile,
  isNewFileMobile: state.widgetReducer.isNewFileMobile
});

const mapDispatchToProps = dispatch => ({
  setCanEdit: canEdit => dispatch(setCanEdit(canEdit)),
  setDisplayTitle: isDisplayTitle => dispatch(setDisplayTitle(isDisplayTitle)),
  setUserName: userName => dispatch(setUserName(userName)),
  setIsNewFile: isNewFile => dispatch(setIsNewFile(isNewFile)),
  setIsNewFileMobile: isNewFileMobile => dispatch(setIsNewFileMobile(isNewFileMobile))
});


export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Widget));



// WEBPACK FOOTER //
// ./src/widget/widget.js